// Constants
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const VAT_CATEGORIES = [
  "Standard 15%",
  "Zero-rated 0%",
  "VAT Exempt Eligible"
];

export const PRODUCTS_PER_PAGE = 100;

// Default new product template
export const defaultProduct = {
  id: null,
  plu_code: "",
  barcode: "",
  barcodes: [],
  name: "",
  description: "",
  category: "",
  department: "",
  supplier: "",
  supplier_plu: "",
  current_stock: 0,
  minimum_level: 0,
  reorder_level: 0,
  maximum_level: 0,
  unit: "units",
  cost_price_excl_vat: 0,
  cost_price_incl_vat: 0,
  last_cost_price_excl_vat: 0,
  average_cost_price_excl_vat: 0,
  selling_price_incl_vat: 0,
  markup_percent: 0,
  vat_rate: 15.0,
  pack_size: 1,
  location: "",
  is_active: true,
  no_discount: false,
  track_expiry: false,
  auto_calculate_stock_levels: false,
  quick_access: false,
  notes: ""
};

// Helper function to calculate total value
export const calculateTotalValue = (product) => {
  const cost = product.average_cost_price_excl_vat || product.last_cost_price_excl_vat || 0;
  return (cost * product.current_stock).toFixed(2);
};

// Generate a unique barcode (EAN-13 style)
export const generateBarcode = () => {
  const timestamp = Date.now().toString().slice(-10);
  const baseCode = "2" + timestamp;
  
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    const digit = parseInt(baseCode[i] || '0');
    sum += i % 2 === 0 ? digit : digit * 3;
  }
  const checkDigit = (10 - (sum % 10)) % 10;
  
  return baseCode + checkDigit;
};
